export const buildProvenance = { "commitHash": "cd1eea50467fc16f496ae78c349ededc3612a721", "branchName": "refs/heads/release/2025.3", "buildDate": "2025-09-25T03:09:30.138Z", "version": "2025.3.14327" };
